const routes = {
    HOME: '/',
    DASHBOARD: '/dashboard',
    NOTES: 'notes',
    NOTE_DETAILS: 'notes/:id',
    ADS: 'adsesce',
    ADS_DETAILS: 'adsesce/:id',
    ADS_CAMPAIGN: 'ads-campaign',
    USERS: 'users',
    USERS_DETAILS: 'users/:id',
    PROFILES: 'profiles',
    PROFILE_DETAILS: 'profiles/:id',
    MAGAZINES: 'magazines',
    MAGAZINE_DETAILS: 'magazines/:id',
    NOTIFICATIONS: 'notifications',
    HEADERS: 'headers',
    HEADER_DETAILS: 'headers/:id',
    SETTINGS: 'settings',
    ADS_SECTIONS: 'adsence-sections',
    ADS_SECTIONS_DETAILS: 'adsence-sections/:id',
    PAGES: 'pages',
    PAGE_DETAILS: 'pages/:id',
    AUTHORS: 'authors',
    AUTHOR_DETAILS: 'authors/:id'
}

export {
    routes
}